<template>
  <div class="cultivation" :class="[zsTjTheme]">
    <div class="left">
      <RoleInfo :dataSource="character" :styleInfo="styleInfo" :resetVisible="resetVisible" @reset="handleReset" />
      <TableData
        :dataSource="attribute"
        :equipmentObj="equipmentObj"
        :skinObj="skinObj"
        :treasureData="treasureData"
        :publicData="publicData"
        :engravingData="engravingData"
        :styleData="dataSource.style"
        :awakeningData="awakeningData"
        :character="character"
      />
    </div>
    <div class="right">
      <Equipment
        :zbListFilt="filterZbList"
        :attribute="attribute"
        :dataSource="calcLanguageEquipment"
        :isEdit="isEdit"
        :currentShowData="currentShowData"
        @update="handleUpdateEquipment"
      />
      <Capacity
        :isOpenKeyin="isOpenKeyin"
        :isOpenJuexing="isOpenJuexing"
        :styleData="dataSource.style"
        :currentSkin="skinObj"
        :treasureData="treasureData"
        :publicData="publicData"
        :initEngraving="initEngraving"
        :initAwakening="initAwakening"
        :engravingData="engravingData"
        :awakeningData="awakeningData"
        @handleSwitch="handleSwitch"
        @update="handleUpdateSkin"
        @updateTreasure="handleUpdateTreasure"
        @updatePublicData="handleUpdatePublic"
        @updateEngravingData="handleUpdateEngraving"
        @updateAwakeningData="handleUpdateAwakening"
      />
    </div>
    <div v-if="this.loginUser.is_super" class="options">
      <template v-if="isEdit">
        <el-button type="primary" @click="handleSave(true)">发布</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSave(false)">保存</el-button>
      </template>
      <el-button v-else type="primary" @click="handleEdit">编辑</el-button>
    </div>

    <!-- 悬浮映射按钮 -->
    <div class="close-map-btn" id="_tj_map_btn_" ref="mapBtn" @click="openMap">
      <svg class="icon" viewBox="0 0 1024 1024" width="16" height="16">
        <path
          d="M329.142857 256a36.571429 36.571429 0 0 1 6.582857 72.557714L329.142857 329.142857h-146.285714a109.714286 109.714286 0 0 0-109.202286 99.181714L73.142857 438.857143v146.285714a109.714286 109.714286 0 0 0 99.181714 109.202286L182.857143 694.857143h292.571428a109.714286 109.714286 0 0 0 109.202286-99.181714L585.142857 585.142857V438.857143a36.571429 36.571429 0 0 1 72.557714-6.582857L658.285714 438.857143v146.285714a182.857143 182.857143 0 0 1-170.861714 182.491429L475.428571 768h-292.571428A182.857143 182.857143 0 0 1 0.365714 597.138286L0 585.142857V438.857143a182.857143 182.857143 0 0 1 170.861714-182.491429L182.857143 256h146.285714z"
          fill="#2c2c2c"
          p-id="31024"
        ></path>
        <path
          d="M694.857143 768a36.571429 36.571429 0 0 1-6.582857-72.557714L694.857143 694.857143h146.285714a109.714286 109.714286 0 0 0 109.202286-99.181714L950.857143 585.142857V438.857143a109.714286 109.714286 0 0 0-99.181714-109.202286L841.142857 329.142857h-292.571428a109.714286 109.714286 0 0 0-109.202286 99.181714L438.857143 438.857143v146.285714a36.571429 36.571429 0 0 1-72.557714 6.582857L365.714286 585.142857V438.857143a182.857143 182.857143 0 0 1 170.861714-182.491429L548.571429 256h292.571428a182.857143 182.857143 0 0 1 182.491429 170.861714L1024 438.857143v146.285714a182.857143 182.857143 0 0 1-170.861714 182.491429l-11.995429 0.365714h-146.285714z"
          fill="#2c2c2c"
          p-id="31025"
        ></path>
      </svg>
    </div>
    <!-- 映射弹框 -->
    <el-dialog
      title="服装数据修改"
      :visible.sync="visible"
      width="500px"
      custom-class="tj-map-dialog"
      center
      :append-to-body="true"
      :before-close="closeMap"
    >
      <div style="width: 100%">
        <div v-for="item in languageList" :key="item.code" class="flex-line">
          <span class="label">{{ item.name }}：</span>
          <el-input
            type="textarea"
            :autosize="true"
            v-model="currentValue[item.code]"
            style="width: 100%"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="flex-line">
          <el-button type="primary" @click="handleOk">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import RoleInfo from "./components/roleInfo.vue";
import TableData from "./components/tableData.vue";
import Equipment from "./components/equipment.vue";
import Capacity from "./components/capacity.vue";

import { apiTjeqList, apiGetLineUpInfo, apiSaveLineUpInfo } from "@/api/zbtjApi";
import { throttle } from "@/plugins/util";
import { createPopper } from "@popperjs/core";
import { mapGetters } from "vuex";

const getDefTreasureData = vm => {
  return [
    {
      name: vm.$t("tj.zs.攻击力"),
      value: "80%"
    },
    {
      name: vm.$t("tj.zs.魔法力"),
      value: "80%"
    },
    {
      name: vm.$t("tj.zs.生命力"),
      value: "80%"
    }
  ];
};

export default {
  components: {
    RoleInfo,
    TableData,
    Equipment,
    Capacity
  },
  props: {
    // Define any props if needed
    dataSource: {
      type: Object,
      default: () => ({})
    },
    contentId: {
      type: Number,
      default: undefined
    },
    // 养成数据
    cultivationData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cultivationData: {
      handler(newVal) {
        if (newVal) {
          // console.log("cultivationData", newVal);
          this.equipmentObj = newVal.equipmentObj || {};
          this.skinObj = newVal.currentSkinObj || {};
          this.treasureData =
            newVal.treasureData && newVal.treasureData.length ? newVal.treasureData : getDefTreasureData(this);
          this.publicData = newVal.publicData || {};
          this.otherFormData = newVal.otherFormData || {};

          this.initData = JSON.parse(JSON.stringify(newVal));
        }
      },
      immediate: true
    },
    dataSource: {
      handler(newVal) {
        if (newVal) {
          if (newVal.base && newVal.base.engraving) {
            const engraving = newVal.base.engraving;

            const result = {};
            for (let i = 0; i < 3; i++) {
              const label = engraving[`label${i + 1}`] || {};
              const value = engraving[`value${i + 1}`] || {};
              if (label.value && value.value) {
                result[label.value] = value.value;
              }
            }

            this.engravingData = JSON.parse(JSON.stringify(result));
            this.initEngraving = JSON.parse(JSON.stringify(result));
          } else {
            this.engravingData = {};
          }

          if (newVal.base && newVal.base.awakening) {
            const awakening = newVal.base.awakening;
            const result = {};
            for (let i = 0; i < 3; i++) {
              const label = awakening[`label${i + 1}`] || {};
              const value = awakening[`value${i + 1}`] || {};
              if (label.value && value.value) {
                result[label.value] = value.value;
              }
            }
            this.awakeningData = JSON.parse(JSON.stringify(result));
            this.initAwakening = JSON.parse(JSON.stringify(result));
          } else {
            this.awakeningData = {};
          }
        }
      },
      immediate: true
    },
    isUserChange: {
      handler(val) {
        if (val) {
          if (window.staticFn) {
            window.staticFn.customEvent("Web_appears_Restore_top_data_button");
          }
        }
      }
    }
  },
  data() {
    return {
      /** 筛选装备 */
      zbListFilt: [],
      // 装备数据
      equipmentObj: {},
      // 皮肤数据
      skinObj: {},
      // 珍藏数据
      treasureData: getDefTreasureData(this),
      // 共用能力值
      publicData: {},
      // 刻印数据
      engravingData: {},
      // 觉醒数据
      awakeningData: {},
      // 初始刻印数据
      initEngraving: {},
      // 初始觉醒数据
      initAwakening: {},
      // 其他静态显示数据
      otherFormData: {},
      submitLoading: false,
      // 保存的初始数据
      initData: {},
      // 运营保存的还未提交的数据
      saveData: {},
      isEdit: false, // 是否编辑状态
      isUserChange: false, // 是否用户修改过数据
      isOpenKeyin: true, // 刻印开关状态
      isOpenJuexing: true, // 觉醒开关状态
      currentKey: "", // 当前映射的键
      currentValue: "", // 当前映射的值
      visible: false, // 控制映射弹窗的显示
      currentEditForm: {} // 当前编辑的表单数据
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme", "languageList", "language"]),
    // Add any computed properties if needed
    resetVisible() {
      return !this.isEdit && this.isUserChange;
    },
    character() {
      return (this.dataSource && this.dataSource.base && this.dataSource.base.character) || {};
    },
    attribute() {
      return (this.dataSource && this.dataSource.base && this.dataSource.base.attr) || {};
    },
    styleInfo() {
      return (this.dataSource && this.dataSource.style && this.dataSource.style.style1) || {};
    },
    // 获取当前角色的装备数据
    filterZbList() {
      const roleName = this.character.name && this.character.name.value;
      const result = this.zbListFilt.filter(
        item => item.type !== "专用" || (item.type === "专用" && item.role_name.indexOf(roleName) !== -1)
      );
      return result.map(item => {
        const mainAttr = item.main_attr ? JSON.parse(item.main_attr) : {};
        return {
          ...item,
          mainAttr: {
            zynl: this.getAttrArray(mainAttr.zynl),
            jbnl1: this.getAttrArray(mainAttr.jbnl1),
            jbnl2: item.type === "专用" ? this.getPropertyList(mainAttr.jbnl2) : this.getAttrArray(mainAttr.jbnl2)
          }
        };
      });
    },
    // 当前要显示的编辑数据
    currentShowData() {
      return this.isEdit ? this.currentEditForm : this.otherFormData;
    },
    // 映射多语言装备数据
    calcLanguageEquipment() {
      const { equipmentObj, filterZbList } = this;
      if (!filterZbList || filterZbList.length === 0) return equipmentObj;
      const keys = Object.keys(equipmentObj);
      const result = {};
      keys.forEach(key => {
        const item = equipmentObj[key];
        if (item && item.content_id) {
          const content_id = item.content_id;
          const zbItem = filterZbList.find(zb => zb.content_id === content_id);
          result[key] = {
            ...item,
            name: zbItem ? zbItem.name : item.name
          };
        } else {
          result[key] = item;
        }
      });
      return result;
    }
  },
  mounted() {
    this.fetchZbList();
    if (this.contentId && this.loginUser.is_super) {
      this.getInfo();
    }
    window.addEventListener("mousemove", this.hideMap, true);
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.hideMap, true);
  },

  methods: {
    handleEdit() {
      this.equipmentObj = JSON.parse(JSON.stringify(this.saveData.equipmentObj || {}));
      this.skinObj = JSON.parse(JSON.stringify(this.saveData.currentSkinObj || {}));
      if (!this.saveData.treasureData || this.saveData.treasureData.length === 0) {
        this.treasureData = getDefTreasureData(this);
      } else {
        this.treasureData = JSON.parse(JSON.stringify(this.saveData.treasureData || []));
      }
      this.publicData = JSON.parse(JSON.stringify(this.saveData.publicData || {}));
      this.currentEditForm = JSON.parse(JSON.stringify(this.saveData.otherFormData || {}));
      this.isEdit = true;

      setTimeout(() => {
        this.initMapElEvent();
      });
    },
    initMapElEvent() {
      const needMapEl = document.querySelectorAll("[data-map-key]");
      needMapEl.forEach(el => {
        el.addEventListener("mouseenter", this.showMap);
      });
    },
    showMap(e) {
      if (!this.isEdit) return;
      const mapKey = e.target.dataset.mapKey;
      const mapBtn = document.getElementById("_tj_map_btn_");
      const currentMapEl = e.target;
      this.currentMapEl = currentMapEl;
      mapBtn.setAttribute("data-show", "");
      mapBtn.setAttribute("data-el-map-key", mapKey);
      createPopper(currentMapEl, mapBtn, {
        placement: "top-start",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          }
        ]
      });
    },

    getInfo() {
      apiGetLineUpInfo({
        content_id: this.contentId
      }).then(res => {
        if (res.code === 0 && res.data.content) {
          try {
            const parseData = JSON.parse(res.data.content);
            this.saveData = parseData;
          } catch (error) {
            console.error("Error parsing content data:", error);
          }
        }
      });
    },
    handleReset() {
      this.isUserChange = false;
      this.equipmentObj = JSON.parse(JSON.stringify(this.initData.equipmentObj || {}));
      this.skinObj = JSON.parse(JSON.stringify(this.initData.currentSkinObj || {}));
      this.treasureData = JSON.parse(JSON.stringify(this.initData.treasureData || []));
      this.publicData = JSON.parse(JSON.stringify(this.initData.publicData || {}));
      this.engravingData = JSON.parse(JSON.stringify(this.initEngraving || {}));
      this.awakeningData = JSON.parse(JSON.stringify(this.initAwakening || {}));
      this.isOpenKeyin = true;
      this.isOpenJuexing = true;
    },
    getPropertyList(string) {
      if (!string) return [];
      const arr = string.split("/");
      return arr.map(item => {
        const [label, value] = item.trim().split(" ");
        return { label, value };
      });
    },
    getAttrArray(string) {
      if (!string) return [];
      const arr = string.split(" ");
      return {
        label: arr[0],
        value: arr[1]
      };
    },
    async fetchZbList() {
      const { code, data } = await apiTjeqList();
      if (code === 0) {
        this.zbListFilt = data || [];
      }
    },
    closeMap() {
      this.visible = false;
      this.currentKey = "";
      this.currentValue = "";
    },

    openMap(e) {
      const mapBtn = document.getElementById("_tj_map_btn_");
      const mapKey = mapBtn.dataset.elMapKey;
      this.currentKey = mapKey;
      const currentVal = this.currentEditForm[mapKey];
      if (currentVal) {
        if (typeof currentVal === "object") {
          const obj = {};
          this.languageList.forEach(item => {
            obj[item.code] = currentVal[item.code] || "";
          });
          this.$set(this, "currentValue", obj);
        } else {
          // 老数据，是个字符串，默认赋值到zh-cn
          const obj = {};
          this.languageList.forEach(item => {
            obj[item.code] = "";
          });
          obj["zh-cn"] = currentVal;
          this.$set(this, "currentValue", obj);
        }
      } else {
        const obj = {};
        this.languageList.forEach(item => {
          obj[item.code] = "";
        });
        this.$set(this, "currentValue", obj);
      }

      this.visible = true;
      // 隐藏映射按钮
      mapBtn.removeAttribute("data-show");
      mapBtn.removeAttribute("data-el-map-key");
      mapBtn.removeAttribute("data-el-map-type");
    },
    hideMap: throttle(function(e) {
      if (this.visible) return;
      if (!this.$refs) return;
      const mapBtn = document.getElementById("_tj_map_btn_");
      const currentEl = e.target;
      if (!(mapBtn.contains(currentEl) || (this.currentMapEl && this.currentMapEl.contains(currentEl)))) {
        mapBtn.removeAttribute("data-show");
        mapBtn.removeAttribute("data-el-map-key");
      }
    }, 500),
    handleOk() {
      this.$set(this.currentEditForm, this.currentKey, this.currentValue);

      this.visible = false;
    },

    handleSave(type) {
      this.submitLoading = true;
      const params = {
        content_id: this.contentId,
        is_sub: type,
        content: JSON.stringify({
          equipmentObj: this.equipmentObj,
          currentSkinObj: this.skinObj,
          treasureData: this.treasureData,
          publicData: this.publicData,
          otherFormData: this.currentEditForm
        })
      };
      apiSaveLineUpInfo(params)
        .then(res => {
          this.submitLoading = false;
          if (res.code === 0) {
            this.$message.success("保存成功");
            window.location.reload();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    // 更新装备数据
    handleUpdateEquipment(data, key) {
      if (!data) {
        const obj = {
          ...this.equipmentObj
        };
        delete obj.content_id;
        this.$set(this, "equipmentObj", obj);
        return;
      }
      const originData = this.equipmentObj[key] || {};
      const obj = {
        ...originData,
        ...data
      };
      const result = {
        ...this.equipmentObj,
        [key]: obj
      };
      this.$set(this, "equipmentObj", result);
      this.isUserChange = true;
    },
    // 更新皮肤
    handleUpdateSkin(data) {
      if (!data) {
        this.$set(this, "skinObj", {});
      }
      this.$set(this, "skinObj", data);
      this.isUserChange = true;
    },
    // 更新珍藏集
    handleUpdateTreasure(data) {
      this.$set(this, "treasureData", data);
      this.isUserChange = true;
    },
    // 更新共用能力值
    handleUpdatePublic(data) {
      this.$set(this, "publicData", data);
      this.isUserChange = true;
    },
    // 更新刻印数据
    handleUpdateEngraving(data) {
      this.$set(this, "engravingData", data);
      this.isUserChange = true;
    },
    // 更新觉醒数据
    handleUpdateAwakening(data) {
      this.$set(this, "awakeningData", data);
      this.isUserChange = true;
    },
    // 切换开关
    handleSwitch(type) {
      if (type === "keyin") {
        this.isOpenKeyin = !this.isOpenKeyin;
        if (this.isOpenKeyin) {
          this.$set(this, "engravingData", JSON.parse(JSON.stringify(this.initEngraving)));
        } else {
          this.$set(this, "engravingData", {});
        }
      } else if (type === "juexing") {
        this.isOpenJuexing = !this.isOpenJuexing;
        if (this.isOpenJuexing) {
          this.$set(this, "awakeningData", JSON.parse(JSON.stringify(this.initAwakening)));
        } else {
          this.$set(this, "awakeningData", {});
        }
      }
      this.isUserChange = true;
    }
  }
};
</script>
<style lang="less" scoped>
.tj-map-dialog {
  .flex-line {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    .label {
      flex: 0 0 auto;
    }
  }
}
.close-map-btn {
  display: none;
  z-index: 2000;
  width: 24px;
  height: 24px;
  background: transparent;
  cursor: pointer;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px;
  align-items: center;
  justify-content: center;
  &[data-show] {
    display: flex;
  }
}

.cultivation {
  position: relative;
  display: flex;
  padding-top: 38px;
  padding-left: 32px;
  margin-left: 190px;
  .options {
    position: absolute;
    right: -62px;
    top: 38px;
    display: flex;
    flex-direction: column;
    .el-button {
      margin-bottom: 10px;
      margin-left: 0;
    }
  }
  .left {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    width: 428px;
    padding-top: 10px;
    margin-right: 35px;
    overflow: hidden;
  }
  .right {
    display: flex;
    flex-direction: column;
  }
}

.cultivation.light {
}
</style>
